import React from 'react';
import { observer } from 'mobx-react-lite';
import { useFlags } from 'launchdarkly-react-client-sdk';

import HomePageRedesign from './home-page-redesign';

function IndexPage() {
  const flags = useFlags();
  const showShopLocal = !!flags?.['growth.ecomm.homepage-v3.show-shop-local'];

  return <HomePageRedesign showShopLocal={showShopLocal} />;
}

export default observer(IndexPage);
